var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.templateCheck === 'home-with-default' && _vm.responseData)?_c('HomeLayout2',{key:_vm.responseData.content.blocks.length,attrs:{"homeLayout2Data":_vm.responseData}}):(_vm.responseData)?_c('HomeLayout1',{key:_vm.responseData.content.blocks.length,attrs:{"homeLayout1Data":_vm.responseData}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2592243a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 596
// module chunks = 1